"use client";

import { useState } from "react";
import { useEffect } from "react";
import { useIsMobile } from "@hooks/use-mobile";
import { CarValuationSeoCard } from "@interfaces/carValuationSeo.types";
import styles from "./CarValuationExpandableGrid.module.scss";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";

interface CarValuationExpandableGridProps {
  items: CarValuationSeoCard[];
  dark?: boolean;
}

export default function CarValuationExpandableGrid({
  items,
  dark = false,
}: CarValuationExpandableGridProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useIsMobile();
  const visibleCount = isMobile ? 2 : 4;
  const shouldCollapse = items.length > visibleCount;
  const visibleItems =
    isHydrated && shouldCollapse && !expanded
      ? items.slice(0, visibleCount)
      : items;

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <div>
      <div className={styles.grid}>
        {visibleItems.map((item, index) => (
          <article
            key={`${item.title}-${index}`}
            className={`${styles.card} ${dark ? styles.darkCard : ""}`}
          >
            {item.image?.url ? (
              <Image
                src={item.image.url}
                alt={item.image.alt}
                width={56}
                height={56}
                className={styles.icon}
              />
            ) : null}
            <h3 className={styles.title}>{item.title}</h3>
            <p className={styles.description}>{item.description}</p>
          </article>
        ))}
      </div>

      {isHydrated && shouldCollapse && (
        <button
        type="button"
        className={styles.viewMore}
        onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? "View less" : "View more"}
          <Image
            src={`${assetLoader()}${
              expanded
                ? "/icons/chevron-up-light.svg"
                : "/icons/expertReview/Chevron_down.svg"
            }`}
            alt=""
            width={24}
            height={24}
          />
        </button>
      )}
    </div>
  );
}
